import React from "react";
import "./WinnersAboutUsBlue.css";
import img from "../../Images/Group (4).png";
import img2 from "../../Images/Group 1171279366 (2).png";
import { BadgeCheck, FileText, FileUser, Handshake, NotepadText, ShieldCheck } from "lucide-react";

const WhyChooseUsBlue = () => {
  const cards = [
    {
      title: "Real-Time Property Data Updates",
      description:
        "We deliver real-time property data sourced directly from verified owners, agents, and builders across Gurgaon, Noida, and South Delhi. Our data is updated daily so you never miss new listings, property leads, or investor opportunities.",
      icon:<FileText />,
      },
    {
      title: "100% Accurate & Verified Property Information",
      description:
        "Every property listing in our database goes through a multi-level verification process to ensure you get only authentic and accurate property information — helping you save time and focus on closing deals faster.",
      icon: <BadgeCheck />,
      },
    {
      title: "Personalized Locality-Wise Solutions",
      description:
        "Whether you deal in luxury apartments in South Delhi or residential plots in Noida Extension, our platform offers customized, area-specific data. This helps you target the right buyers and sellers within your preferred localities.",
      icon:<FileUser />,
      },
    {
      title: "Verified Owner, Buyer & Dealer Contacts",
      description:
        "Access a large collection of verified phone numbers and contact details of property owners, dealers, and investors. Every contact is validated, ensuring higher conversion rates and genuine business growth.",
      icon:<ShieldCheck/>,
      },
    {
      title: "Flexible & Affordable Subscription Plans",
      description:
        "Choose from monthly, quarterly, or yearly subscription plans designed for real estate agents, brokers, and property consultants. Pay only for the data you need and scale as your business grows.",
      icon:<NotepadText />,
      },
    {
      title: "Expert Support & Data Assistance",
      description:
        "Our dedicated support team is always available to help you with data setup, customization, and real-time query resolution — making your subscription experience smooth and result-driven.",
      icon:<Handshake />,
      },
  ];

  return (
    // <section className="why_choose_us_section_blue">
    //   <h1>Why Choose Us</h1>
    //   <div className="why_choose_us_card_wrapper_blue">
    //     {cards.map((e, i) => {
    //       return (
    //         <div className="why_card_blue" key={i}>
    //           <div className="card_img_blue">
    //             <img src={img} alt="Why Choose Us Icon" />
    //           </div>
    //           <p className="perfect_para_blue">{e?.title}</p>
    //           <p className="perfect_para2_blue">{e?.description}</p>
    //         </div>
    //       );
    //     })}
    //   </div>
    //   <img className="img_bg_blue" src={img2} alt="Background shape" />
    // </section>
    <section className="why-modern-blue">

  <div className="why-header-blue">
    <span className="why-tag-blue">
      Why Choose Winners
    </span>

    <h2>
      Trusted By Real Estate
      <span> Professionals Across NCR</span>
    </h2>

    <p>
      Our platform combines verified property intelligence,
      real-time updates, and dedicated support to help
      brokers, consultants, and agencies close more deals.
    </p>
  </div>

  <div className="why-grid-blue">
    {cards.map((item, index) => (
      <div className="why-card-modern-blue" key={index}>

        <div className="why-card-top-blue">

          <div className="why-icon-blue">
            {/* <img src={img} alt="" /> */}
            {item.icon}
          </div>

          <span className="why-number-blue">
            0{index + 1}
          </span>

        </div>

        <h3>{item.title}</h3>

        <p>{item.description}</p>

      </div>
    ))}
  </div>

</section>
  );
};

export default WhyChooseUsBlue;
